export default __webpack_public_path__ + "c2723f8b56b836abc022045519999ea5.svg";